export default "__VITE_ASSET__ffc68464__"